import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export function BlogSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="blog"
      data-testid="blog-section"
      ref={ref}
      className="relative py-20 px-6"
    >
      <div className="max-w-7xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="space-y-6"
        >
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-temple-red font-body">
            Thoughts & Explorations - The Blog
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-[#8B4513] mt-4">
            The <span className="italic">Rabbit Hole Effect</span>
          </h2>
          <p className="font-body text-muted-foreground text-lg max-w-2xl mx-auto">
            Where I document my explorations, from building audit tools with code to
            dissecting industry problems down the rabbit hole.
          </p>
          <motion.div whileHover={{ y: -2 }}>
            <Link
              to="/blog"
              className="inline-flex items-center gap-3 mt-6 px-8 py-3 border border-vedic-gold/40 
                text-vedic-gold font-body text-sm uppercase tracking-widest 
                hover:bg-vedic-gold hover:text-black transition-all duration-300 group"
            >
              Read my blog
              <ArrowRight size={16} className="group-hover:translate-x-2 transition-transform" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
